<template>
    <div>
        <h1>Adding...</h1>
    </div>
</template>

<script>
import guests from "../services/guests";

export default {
    name: "addGuestToSchedule",
    props: [
    	"event_id",
    	"schedule_id",
    	"external_id"
    ],
    created() {
        console.debug("addGuestToSchedule", "created");
        guests.checkin(this.$props.event_id, this.$props.schedule_id, this.$props.external_id);
    }
};
</script>